export default __webpack_public_path__ + "static/media/close-menu-icon.54ba05a9.svg";